import { SET_CLIENT_REFERRER } from 'actions';

export function setClientReferrer(sourceType: string) {
  return { sourceType, type: SET_CLIENT_REFERRER };
}
